
{
  "fr": {
    "distance": "{distance} km"
  }
}
